import React, { useEffect, useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';

// import { Swiper, SwiperSlide } from "swiper/react";

const React = require('react');
const wrapper = document.getElementById('inno3d-product-listing');
const showProductNumber = 12;
const App = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [apiData, setApiData] = useState({});
    const [productTypeData, setProductTypeData] = useState({});
    const [isDesktopSize, setIsDesktopSize] = useState(true);

    const [resultProductList, setResultProductList] = useState([]);
    const [showProductList, setShowProductList] = useState([]);
    const [showProductCounter, setShowProductCounter] = useState(0);

    const [selectedClassFilterList, setSelectedClassFilterList] = useState([]);
    const [selectedGpuFilterList, setSelectedGpuFilterList] = useState([]);
    const [selectedCoolingFilterList, setSelectedCoolingFilterList] = useState([]);
    const [selectedEnterpriseCategoryFilterList, setSelectedEnterpriseCategoryFilterList] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const [productCompare, setProductCompare] = useState([
        {"title": "empty", "nid": -1}, {"title": "empty", "nid": -1}, {"title": "empty", "nid": -1}
    ]);
    const [productCompareLength, setProductCompareLength] = useState();
    const [productCompareIsShow, setProductCompareIsShow] = useState(false);
    const [mobileFilterLabelIndex, setMobileFilterLabelIndex] = useState();

    const observeRef = useRef(null);

    const [pageParams, setPageParams] = useState([]);

    useEffect(() => {
        fetchData();
        handleResize();
        window.addEventListener('resize', handleResize);
    }, [])

    useEffect(() => {
        if(isLoaded) {    
            setResultProductList([...apiData.data.products]);
            var queryString = window.location.search;   
            queryString = new URLSearchParams(queryString);
            var searchParam = queryString.get('search');
            var classParam = queryString.get('class');
            if (searchParam){
                document.querySelector('input[name="search"]').value = searchParam
                setSearchValue(searchParam)
            }
            if (classParam){
                var classParamArray = classParam.split(',');
                classParamArray.forEach((param) => {
                    document.querySelector('input[data-value="'+param+'"]').click();
                    // document.querySelector('input:contains(' + param + ')').click();
                })
                // document.querySelector('input[data-id="'+classParam+'"]').click();
                //selectFilter(apiData.taxonomy_terms)
                //selectFilter(classParam)
            }
        }
    }, [isLoaded])

    useEffect(() => {
        if(resultProductList.length !== 0){
            for(let i = 0; i < showProductNumber; i++){
                if(i >= resultProductList.length){
                    break;
                }
                setShowProductList(prevShowProductList => (
                    [...prevShowProductList, resultProductList[i]]
                ))
            }
        }
    }, [resultProductList])

    useEffect(() => {        
        if(showProductCounter > resultProductList.length){
            setShowProductCounter((prevShowProductCounter) => resultProductList.length);
            return;
        }
        if(resultProductList.length !== 0 && showProductCounter >= showProductNumber){
            for(let i = showProductCounter; i < showProductCounter + showProductNumber; i++){
                if(i >= resultProductList.length){
                    break;
                }
                setShowProductList((prevShowProductList) => 
                    [...prevShowProductList, resultProductList[i]]
                )
            }
        }
    }, [showProductCounter])

    // useEffect(() => {
    //     const productListingBottomObserver = new IntersectionObserver(
    //         (e) => {
    //             if(e[0].isIntersecting){
    //                 setTimeout(() => {
    //                     setShowProductCounter((prevShowProductCounter) => prevShowProductCounter + showProductNumber);
    //                 }, 300)
    //             }
    //         },
    //         { threshold: 1.0 }
    //     );

    //     if(observeRef.current){
    //         productListingBottomObserver.observe(observeRef.current);
    //     }
    // }, [observeRef])

    // useEffect(() => {
    //     if(isLoaded) {
    //         updateProductList();
    //     }
    // },[selectedFilterList])

    useEffect(() => {
        if(isLoaded) {
            updateProductList();
        }
    },[selectedClassFilterList])

    useEffect(() => {
        if(isLoaded) {
            updateProductList();
        }
    },[selectedGpuFilterList])

    useEffect(() => {
        if(isLoaded) {
            updateProductList();
        }
    },[selectedCoolingFilterList])

    useEffect(() => {
        if(isLoaded) {
            updateProductList();
        }
    },[selectedEnterpriseCategoryFilterList])

    useEffect(() => {
        if(isLoaded) {
            updateProductList();
        }
    }, [searchValue])

    useEffect(() => {
        checkProductCompareLength();
    }, [productCompare])

    useEffect(() => {
        updateParams();
    }, [pageParams])

    const fetchData = async() => {
        const productType = wrapper.getAttribute('type');
        const res = await fetch('/api/product-listing/' + productType);
        const data = await res.json();
        setProductTypeData(productType);
        setApiData(data);
        setIsLoaded(true);
    }

    const handleResize = () => {
        setIsDesktopSize(window.innerWidth > 1000);
    };

    const selectFilter = (term, group) => {
        const tid = term.tid;
        const children = term.children;

        var index;

        if(productTypeData == 'inno3d_pd_gr'){
            if(group == 'Class'){
                index = selectedClassFilterList.map(filter => filter.tid).indexOf(tid);
                if(index !== -1){
                    setSelectedClassFilterList((selectedClassFilterList) => selectedClassFilterList.filter((filter) => filter.tid !== tid));
                    setPageParams((pageParams) => pageParams.filter((filter) => filter !== term.title));
                    document.querySelector('input[data-id="'+tid+'"]').checked = false;
                }else{
                    setSelectedClassFilterList((selectedClassFilterList) => [...selectedClassFilterList, {tid: tid, group: group}]);
                    setPageParams((pageParams) => [...pageParams, term.title]);
                    document.querySelector('input[data-id="'+tid+'"]').checked = true;
                }
    
                if(children){
                    children.forEach((child) => {
                        if(index == -1 && selectedClassFilterList.map(filter => filter.tid).indexOf(child.tid) == -1){
                            selectFilter(child,group);
                        }else if(index !== -1 && selectedClassFilterList.map(filter => filter.tid).indexOf(child.tid) !== -1){
                            selectFilter(child,group);
                        }
                    })
                }
                   
            }else if (group == 'GPU'){
                index = selectedGpuFilterList.map(filter => filter.tid).indexOf(tid);
                if(index !== -1){
                    setSelectedGpuFilterList((selectedGpuFilterList) => selectedGpuFilterList.filter((filter) => filter.tid !== tid));
                    setPageParams((pageParams) => pageParams.filter((filter) => filter !== term.title));
                    document.querySelector('input[data-id="'+tid+'"]').checked = false;
                }else{
                    setSelectedGpuFilterList((selectedGpuFilterList) => [...selectedGpuFilterList, {tid: tid, group: group}]);
                    setPageParams((pageParams) => [...pageParams, term.title]);
                    document.querySelector('input[data-id="'+tid+'"]').checked = true;
                }
    
                if(children){
                    children.forEach((child) => {
                        if(index == -1 && selectedGpuFilterList.map(filter => filter.tid).indexOf(child.tid) == -1){
                            selectFilter(child,group);
                        }else if(index !== -1 && selectedGpuFilterList.map(filter => filter.tid).indexOf(child.tid) !== -1){
                            selectFilter(child,group);
                        }
                    })
                }
            }else if (group == 'Cooling'){
                index = selectedCoolingFilterList.map(filter => filter.tid).indexOf(tid);
                if(index !== -1){
                    setSelectedCoolingFilterList((selectedCoolingFilterList) => selectedCoolingFilterList.filter((filter) => filter.tid !== tid));
                    setPageParams((pageParams) => pageParams.filter((filter) => filter !== term.title));
                    document.querySelector('input[data-id="'+tid+'"]').checked = false;
                }else{
                    setSelectedCoolingFilterList((selectedCoolingFilterList) => [...selectedCoolingFilterList, {tid: tid, group: group}]);
                    setPageParams((pageParams) => [...pageParams, term.title]);
                    document.querySelector('input[data-id="'+tid+'"]').checked = true;
                }
    
                if(children){
                    children.forEach((child) => {
                        if(index == -1 && selectedCoolingFilterList.map(filter => filter.tid).indexOf(child.tid) == -1){
                            selectFilter(child,group);
                        }else if(index !== -1 && selectedCoolingFilterList.map(filter => filter.tid).indexOf(child.tid) !== -1){
                            selectFilter(child,group);
                        }
                    })
                }
            }
        }else if(productTypeData == 'inno3d_pd_ep'){
            if (group == 'Category'){
                index = selectedEnterpriseCategoryFilterList.map(filter => filter.tid).indexOf(tid);
                if(index !== -1){
                    setSelectedEnterpriseCategoryFilterList((selectedCoselectedEnterpriseCategoryFilterListolingFilterList) => selectedEnterpriseCategoryFilterList.filter((filter) => filter.tid !== tid));
                    setPageParams((pageParams) => pageParams.filter((filter) => filter !== term.title));
                    document.querySelector('input[data-id="'+tid+'"]').checked = false;
                }else{
                    setSelectedEnterpriseCategoryFilterList((selectedEnterpriseCategoryFilterList) => [...selectedEnterpriseCategoryFilterList, {tid: tid, group: group}]);
                    setPageParams((pageParams) => [...pageParams, term.title]);
                    document.querySelector('input[data-id="'+tid+'"]').checked = true;
                }
    
                if(children){
                    children.forEach((child) => {
                        if(index == -1 && selectedEnterpriseCategoryFilterList.map(filter => filter.tid).indexOf(child.tid) == -1){
                            selectFilter(child,group);
                        }else if(index !== -1 && selectedEnterpriseCategoryFilterList.map(filter => filter.tid).indexOf(child.tid) !== -1){
                            selectFilter(child,group);
                        }
                    })
                }
            }
        }
    }

    const updateProductList = () => {
        setShowProductCounter((prevShowProductCounter) => 0);
        setShowProductList((prevShowProductList) => []);
        var tempResultProductList = [...apiData.data.products];
        apiData.data.products.forEach((productItem) => {
            const productIndex = tempResultProductList.indexOf(productItem);
            var isInTheList = false;

            if(productTypeData == 'inno3d_pd_gr'){
                if(productItem.taxonomy.length !== 0){
                    var classCheck = false;
                    var gpuCheck = false;
                    var coolingCheck = false;
                    if(selectedClassFilterList.length !== 0){
                        selectedClassFilterList.forEach((filterItem) => {
                            var taxonomyIndex = -1;
                            if(productItem.taxonomy[0].list.length !== 0){
                                taxonomyIndex = productItem.taxonomy[0].list.indexOf(filterItem.tid);
                            }
    
                            if(taxonomyIndex !== -1){
                                classCheck = true;
                            }
                        })
                    }else{
                        classCheck = true;
                    }
    
                    if(selectedGpuFilterList.length !== 0){
                        selectedGpuFilterList.forEach((filterItem) => {
                            var taxonomyIndex = -1;
                            if(productItem.taxonomy[1].list.length !== 0){
                                taxonomyIndex = productItem.taxonomy[1].list.indexOf(filterItem.tid);
                            }
        
                            if(taxonomyIndex !== -1){
                                gpuCheck = true;
                            }
                        })
                    }else{
                        gpuCheck = true;
                    }
    
                    if(selectedCoolingFilterList.length !== 0){
                        selectedCoolingFilterList.forEach((filterItem) => {
                            var taxonomyIndex = -1;
                            if(productItem.taxonomy[2].list.length !== 0){
                                taxonomyIndex = productItem.taxonomy[2].list.indexOf(filterItem.tid);
                            }
        
                            if(taxonomyIndex !== -1){
                                coolingCheck = true;
                            }
                        })
                    }else{
                        coolingCheck = true;
                    }
    
                    if(classCheck && gpuCheck && coolingCheck){
                        isInTheList = true;
                    }
                }
    
                if(selectedClassFilterList.length == 0 && selectedGpuFilterList.length == 0 && selectedCoolingFilterList.length == 0){
                    isInTheList = true;
                }
            }else if(productTypeData == 'inno3d_pd_ep'){
                if(productItem.taxonomy.length !== 0){
                    var categoryCheck = false;
                    if(selectedEnterpriseCategoryFilterList.length !== 0){
                        selectedEnterpriseCategoryFilterList.forEach((filterItem) => {
                            var taxonomyIndex = -1;
                            if(productItem.taxonomy[0].list.length !== 0){
                                taxonomyIndex = productItem.taxonomy[0].list.indexOf(filterItem.tid);
                            }
    
                            if(taxonomyIndex !== -1){
                                categoryCheck = true;
                            }
                        })
                    }else{
                        categoryCheck = true;
                    }
    
                    if(categoryCheck){
                        isInTheList = true;
                    }
                }
    
                if(selectedEnterpriseCategoryFilterList.length == 0){
                    isInTheList = true;
                }
            }

            if(searchValue.length !== 0 && productItem.title && productItem.part_no){
                if(!productItem.title.toLowerCase().includes(searchValue.toLowerCase()) && !productItem.part_no.toLowerCase().includes(searchValue.toLowerCase())){
                    isInTheList = false;
                }
            }

            if(isInTheList == false){
                var newResultProductList = [...tempResultProductList];
                newResultProductList.splice(productIndex, 1);
                tempResultProductList = [...newResultProductList];
            }
        })
        setResultProductList([...tempResultProductList]);
        // console.log(tempResultProductList);
    }

    const updateCompareList = (nid, title) => {
        const index = productCompare.map((product)=>product.nid).indexOf(nid);

        if(index !== -1){
            const newProductCompare = [...productCompare];
            newProductCompare.splice(index, 1);
            setProductCompare([...newProductCompare, ({"title": "empty", "nid": -1})]);
        }else{
            const item = {
                'title' : title,
                'nid' : nid
            }
            for(let i = 0; i < 3; i++){
                if(productCompare[i].nid == -1){
                    const newProductCompare = [...productCompare];
                    newProductCompare[i] = item;
                    setProductCompare([...newProductCompare]);
                    break;
                }
            }
        }
    }

    const checkProductCompareLength = () => {
        var count = 0;
        var isShow = false;
        productCompare.forEach((product) => {
            if(product.nid !== -1){
                isShow = true;
                count++;
            }
        })
        setProductCompareIsShow(isShow);
        setProductCompareLength(count);
    }

    const clearCompareList = () => {
        setProductCompare([
            {"title": "empty", "nid": -1}, {"title": "empty", "nid": -1}, {"title": "empty", "nid": -1}
        ]);
    }

    const updateMobileFilterLabelIndex = (filterIndex) => {
        if(mobileFilterLabelIndex == filterIndex){
            setMobileFilterLabelIndex();
        }else{
            setMobileFilterLabelIndex(filterIndex);
        }
    }

    const updateParams = () => {
        if(isLoaded) {    
            let url = new URL(window.location.href)

            let params = pageParams.toString();

            url.searchParams.set('class', params);

            window.history.pushState({}, '', url.search)
        }
    }

    const title = wrapper.getAttribute('title');

    const mobileFilterLabel =
        isLoaded ? (
            apiData.data.taxonomy_terms.map((taxonomy, index) =>
                <div className={index == mobileFilterLabelIndex ? 'inno3d-product-listing__filter-mobile-item is-active' : 'inno3d-product-listing__filter-mobile-item'} onClick={() => updateMobileFilterLabelIndex(index)}>{taxonomy.title}</div>
            )
        ) : '';

    const filterList = 
        isLoaded ? (
            apiData.data.taxonomy_terms.map((taxonomy, index) => 
                    <div className="container" style={{display: index !== mobileFilterLabelIndex && !isDesktopSize ? 'none' : ''}}>
                        <div className="inno3d-product-listing__filter-item top-blue-linear-border">
                            <div className="inno3d-product-listing__filter-item--body">
                                <h4 className="inno3d-product-listing__filter-item--title">
                                    {taxonomy.title}
                                </h4>
                                <div className="inno3d-product-listing__filter-item--options">
                                    {taxonomy.list.map((option) =>
                                        <div className="inno3d-product-listing__filter-item-option">
                                            <div class="inno3d-product-listing__filter-item-option--title">
                                                <input className="inno3d-checkbox" type="checkbox" onChange={() => selectFilter(option,taxonomy.title)} data-id={option.tid} data-group={taxonomy.title} data-value={option.title} />{option.title}
                                            </div>
                                            {option.children ? (
                                                <div class="inno3d-product-listing__filter-item--options level-2">
                                                    {option.children.map((child) => 
                                                        <div class="inno3d-product-listing__filter-item-option level-2">
                                                            <div class="inno3d-product-listing__filter-item-option--title level-2">
                                                                <input className="inno3d-checkbox" type="checkbox" onChange={() => selectFilter(child,taxonomy.title)} data-id={child.tid} data-group={taxonomy.title} data-value={child.title} />{child.title}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ):''}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="inno3d-product-listing__filter-item--confirm" onClick={() => updateMobileFilterLabelIndex(index)}></div>
                        </div>
                    </div>
                )
        )  : '';
    
    const productList = 
        isLoaded ? (
            showProductList.length !== 0 ? (
                showProductList.map((product) =>
                    isDesktopSize ? (
                        <div className={productCompare.map((productForCompare)=>productForCompare.nid).indexOf(product.nid) == -1 ? 'inno3d-product-listing__product-item' : 'inno3d-product-listing__product-item selected'}>
                            <div className="inno3d-product-listing__product-item--overlay"></div>
                            <div className="inno3d-product-listing__product-item--info">
                                <div className="inno3d-product-listing__product-item--image">
                                    <a href={product.url} target='_blank'><img src={product.thumb.path} alt={product.thumb.alt} /></a>
                                </div>
                                <div className="inno3d-product-listing__product-item--title"><a href={product.url} target='_blank'>{product.title}</a></div>
                                <div className="inno3d-product-listing__product-item--part-number">{product.part_no}</div>
                            </div>
                            <div className="inno3d-product-listing__product-item--add-compare" onClick={() => updateCompareList(product.nid, product.title)}>
                                {
                                    productCompare.map((productForCompare)=>productForCompare.nid).indexOf(product.nid) == -1 ? 
                                        ('COMPARE')
                                    : ('ADDED TO COMPARE')
                                }
                            </div>
                        </div>
                    ) : (
                        <div className={productCompare.map((productForCompare)=>productForCompare.nid).indexOf(product.nid) == -1 ? 'inno3d-product-listing__product-item' : 'inno3d-product-listing__product-item selected'}>
                            <div className="inno3d-product-listing__product-item--overlay"></div>
                            <div className="inno3d-product-listing__product-item--left">
                                <div className="inno3d-product-listing__product-item--image">
                                    <a href={product.url} target='_blank'><img src={product.thumb.path} alt={product.thumb.alt} /></a>
                                </div>
                                <div className="inno3d-product-listing__product-item--add-compare" onClick={() => updateCompareList(product.nid, product.title)}>
                                    {
                                        productCompare.map((productForCompare)=>productForCompare.nid).indexOf(product.nid) == -1 ? 
                                            ('COMPARE')
                                        : (<span><i class="fa-solid fa-check"></i>ADDED</span>)
                                    }
                                </div>
                            </div>
                            <div className="inno3d-product-listing__product-item--right">
                                <div className="inno3d-product-listing__product-item--title"><a href={product.url} target='_blank'>{product.title}</a></div>
                                <div className="inno3d-product-listing__product-item--part-number">{product.part_no}</div>
                            </div>
                        </div>
                    )
                )
            ) : (
                <div>no result</div>
            )
        ) : '';

    const compareProductList = 
        isLoaded ? (
            productCompare.length !== 0 ? (
                <div className="inno3d-product-listing__compare-list">
                    {
                        productCompare.map((productForCompare) => 
                            productForCompare.nid !== -1 ? (
                                <div className="inno3d-product-listing__compare-list-item">
                                    <div className="inno3d-product-listing__compare-list-item--text">{productForCompare.title}</div>
                                    <div className="inno3d-product-listing__compare-list-item--close-button" onClick={() => updateCompareList(productForCompare.nid, productForCompare.title)}>
                                        <i class="fa-light fa-xmark"></i>
                                    </div>
                                </div>
                            ) : (
                                <div className="inno3d-product-listing__compare-list-item empty-item">Select up to 3 products to compare</div>
                            )
                        )
                    }
                </div>
            ) : ''
        ): '';

    const compareLink = "/product/product-comparison?item=" + productCompare.map((productForCompare) => productForCompare.nid).toString();

    return(
        <div className="inno3d-product-listing__body">
            <div className="container">
                <div className="inno3d-product-listing__top-section">
                    <h2 className="inno3d-product-listing__title">{title}</h2>
                    { isDesktopSize ? (
                        <div className="inno3d-product-listing__show-number">Showing {showProductList.length} of {resultProductList.length} results</div>
                    ) : ''}
                </div>
            </div>
            <div className="inno3d-product-listing__bottom-section container">
                <div className="inno3d-product-listing__filter-container">
                    <div className="inno3d-product-listing__filter-search">
                        <input type="text" name="search" placeholder="Search" onChange={e => setSearchValue(e.target.value)}/>
                    </div>
                    <div className="inno3d-product-listing__filter-mobile-list">{mobileFilterLabel}</div>
                    <div className="inno3d-product-listing__filter-list">{filterList}</div>
                </div>
                { !isDesktopSize ? (
                        <div className="inno3d-product-listing__show-number">show {showProductList.length} of {resultProductList.length} result</div>
                ) : ''}
                <div className="inno3d-product-listing__product-container">
                    <div className="inno3d-product-listing__product-list">{productList}</div>
                    <div className="inno3d-product-listing__product-load-more" 
                        // ref={observeRef}  
                        style={{ opacity: resultProductList.length !== showProductList.length ? 1 : 0 }}
                    >
                        {/* <i class="fa-solid fa-loader"></i>Loading */}
                        <div className="inno3d-product-listing__product-load-more__button" onClick={e => setShowProductCounter((prevShowProductCounter) => prevShowProductCounter + showProductNumber)}>Load More</div>
                    </div>
                </div>
            </div>
            {
                productCompareIsShow ? (
                    <div className="inno3d-product-listing__compare">
                        <div className="inno3d-product-listing__compare-container container">
                            {compareProductList}
                            <div className="inno3d-product-listing__compare-button-section">
                                <div className="inno3d-product-listing__clear-button" onClick={() => clearCompareList()}>Clear all</div>
                                <a className="btn-blue inno3d-product-listing__compare-button" href={productCompareLength > 1 ? (compareLink) : '#'} target={productCompareLength == 1 ? ('_blank') : ''} >
                                    compare
                                    { !isDesktopSize ? (<span> {productCompareLength} / 3</span>) : ''}
                                </a>
                            </div>
                        </div>
                    </div>
                ) : '' 
            }
        </div>
    )
}

ReactDOM.render(<App />, wrapper);
